import React from "react";
import { Tag } from "antd";

function InstructorClass(props) {
  const classes = props.data?.teacher?.classes || [];

  return (
    <>
      <div className="pt-8">
        <div
          style={{ borderRadius: "10px", color: "#616161" }}
          className="bg-white drop-shadow-md p-5 w-full"
        >
          <div className="text-lg font-semibold mb-4">Assigned Classes</div>
          {classes.length > 0 ? (
            <div className="flex flex-wrap gap-5 p-6">
              {classes.map((classItem) => (
                <Tag
                  key={classItem._id}
                  color="blue"
                  style={{
                    fontSize: "14px",
                    padding: "8px 16px",
                    borderRadius: "6px",
                  }}
                >
                  {classItem.name}
                </Tag>
              ))}
            </div>
          ) : (
            <div className="text-gray-500">No classes assigned</div>
          )}
        </div>
      </div>
    </>
  );
}

export default InstructorClass;
